// 文章中心
import request from "@/utils/request.js";
// let path = "/api";
const Product = {
  /**
   * 产品分类查询
   * @param startStatus @type Number ENABLE("启用", 1), DISABLE("禁用", 2);
   * @param page @type String 页码
   * @param pageSize @type String 条数
   */
  productCategoryList: async (data) => {
    return await request("post", "/product/type/list", data);
  },
  /**
   * 产品分类-添加/修改
   * @param delStatus @type Number 0：未删除, 1：已删除;
   * @param page @type String 页码
   * @param createTime @type String 创建时间
   * @param name @type String 产品类型名称
   * @param startStatus @type Number 启用状态（1：启用，0：禁用）
   */
  addOrUpDateProductCategory: async (data) => {
    return await request("post", "/product/type/add", data);
  },

  /**
   * 产品分类-下拉框
   * @param startStatus @type Number ENABLE("启用", 1), DISABLE("禁用", 2);
   */
  dropdownList: async (data) => {
    return await request("post", "/product/type/dropdown", data);
  },

  /**
   * 产品分类删除
   * @param id @type String 产品id;
   */
  delList: async (data) => {
    return await request("get", "/product/type/logic-del", data);
  },

  /**
   * 产品列表-添加
   * @param id @type String 主键 ID，UUID 自动生成;
   *  @param productTypeId @type String 产品分类 ID（下拉框选项的值）;
   *  @param productName @type String 产品名称;
   *  @param model @type String 产品型号;
   *  @param salesPhone @type String 销售电话;
   *  @param brief @type String 产品简介（简要描述）;
   *  @param enable @type String 是否启用：1=启用，2=禁用;
   *  @param productDescription @type String 产品介绍（HTML富文本内容）;
   *  @param delStatus @type String 删除状态，默认 0=未删除;
   *  @param createTime @type String 创建时间;
   *  @param betterStatus @type String 推荐产品配置 1=启用，2=禁用;
   */
  addOrUpDateProductList: async (data) => {
    return await request("post", "/product/data/add", data);
  },

  /**
   * 产品列表-查询
   * @param productName @type String 产品名称，模糊匹配（LIKE 查询）;
   * @param productTypeId @type String 产品分类 ID
   * @param startTime @type String 开始时间;
   * @param endTime @type String 结束时间;
   * @param page @type Number 分页页码;
   * @param pageSize @type Number 条数;
   */
  queryList: async (data) => {
    // return await request("post", "/product/data/list", data);
    return await request("post", "/product/data/list/before", data);
  },

  /**
   * 产品详情-查询
   * @param projectId @type String 产品ID
   */
  getDetail: async (params) => {
    return await request("get", "/product/data/detail", params);
  },
};
export default Product;



// WEBPACK FOOTER //
// ./src/api/product.js